export default (accountsUrl) => window.location.replace(`${accountsUrl}/login?redirect=${window.location}`);
//# sourceMappingURL=loginRedirect.js.map